// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__uxioC","withTabs":"styles_withTabs__8kVuN"};